{
  "legalDocumentAvailabilityCategories": {
    "present": "Present",
    "notPresent": "Not set",
    "notAvailable": "Not available"
  },
  "cookieBar": {
    "text": "Mobile School uses only essential cookies. <a>Here</a> you can find our Cookie Policy",
    "button": "I understand"
  },
  "accountStatusFilter": {
    "disabled": "Disabled",
    "enabled": "Enabled"
  },
  "boolean": {
    "false": "No",
    "true": "Yes"
  },
  "buttons": {
    "add": "Add",
    "cancel": "Cancel",
    "edit": "Edit",
    "merge": "Merge",
    "save": "Save"
  },
  "confidenceAndLearningStatus": {
    "CONFIDENCE": "Confidence",
    "LEARNING": "Learning status"
  },
  "errors": {
    "api": {
      "billing_info_not_found": "Billing info not found",
      "forbidden": "You don't have the required rights to perform the action.",
      "invalid_grant": "Invalid credentials. Please verify them and try again.",
      "organization_duplicate_name": "Invalid organization name",
      "user_email_duplicate": "User already registered",
      "user_no_other_user_with_admin_role": "At least one user with admin role must be in the organization",
      "participant_is_disabled": "You cannot share a 'deactivated' participant.",
      "session_deletion_failed": "You cannot delete an intervention with registered participants."
    },
    "custom": {
      "unknown": "An unknown error occured. If the error persists please contact us."
    }
  },
  "genders": {
    "ALL": "All",
    "FEMALE": "Female",
    "MALE": "Male",
    "OTHER": "Other"
  },
  "goalState": {
    "CANCELED": "Canceled",
    "COMPLETED": "Realised",
    "FAILED": "Failed",
    "IN_PROGRESS": "Open"
  },
  "header": {
    "profile": {
      "view": "View my profile",
      "signOut": "Sign out"
    }
  },
  "inputs": {
    "activitiesSearch": {
      "label": "Search activity",
      "placeholder": "Ethics"
    },
    "activityType": {
      "label": "Activity type",
      "placeholder": "Select type"
    },
    "vendorName": {
      "label": "Vendor name",
      "placeholder": "Enter vendor name"
    },
    "special": {
      "label": "Special vendor",
      "paceholder": "Special vendors are not included in the list of vendors."
    },
    "image": {
      "label": "Image",
      "placeholder": "Upload image"
    },
    "chart": {
      "csv": "Download CSV",
      "jpg": "Download JPG"
    },
    "city": {
      "label": "City",
      "placeholder": "City"
    },
    "confirmedPassword": {
      "label": "New password confirmation",
      "placeholder": "Type your new password again"
    },
    "contactEmail": {
      "label": "Contact E-Mail",
      "placeholder": "john.smith@domain.com"
    },
    "contactFirstName": {
      "label": "Contact First Name",
      "placeholder": "John"
    },
    "contactLastName": {
      "label": "Contact Last Name",
      "placeholder": "Smith"
    },
    "contactSearch": {
      "label": "Search by name",
      "placeholder": "John Smith"
    },
    "contactType": {
      "label": "Contact type",
      "placeholder": "Select type"
    },
    "country": {
      "label": "Country",
      "placeholder": "Country"
    },
    "create": "Create",
    "createNewOrg": "Create new",
    "customPropertyName": {
      "label": "Field name",
      "placeholder": "Enter field name"
    },
    "customPropertyType": {
      "label": "Input type",
      "placeholder": "Select input type"
    },
    "cvc": {
      "label": "CVC"
    },
    "dataOptionName": {
      "label": "Data option name",
      "placeholder": "Enter data option name"
    },
    "daysInterval": {
      "label": "Interval",
      "optionLabel": "{day, plural, one {# day} other {# days}}"
    },
    "educationLevel": {
      "label": "Education level",
      "placeholder": "Education level"
    },
    "email": {
      "label": "Email address",
      "placeholder": "john.smith@domain.com"
    },
    "spotLimit": {
      "label": "Spot Limit",
      "placeholder": "Enter spot limit"
    },
    "emailLanguage": {
      "label": "System email language",
      "placeholder": "Select language"
    },
    "emergencyContactName": {
      "label": "Emergency contact",
      "placeholder": "Police"
    },
    "emergencyContactSearch": {
      "label": "Search emergency contact",
      "placeholder": "Police"
    },
    "endTime": {
      "label": "End time",
      "placeholder": "15:30"
    },
    "firstName": {
      "label": "First Name",
      "placeholder": "John"
    },
    "frequency": {
      "label": "Frequency",
      "placeholder": "Frequency"
    },
    "fullName": {
      "label": "Full name",
      "placeholder": "John Smith"
    },
    "gender": {
      "label": "Gender",
      "placeholder": "Select a gender"
    },
    "goalDescription": {
      "label": "Goal description",
      "placeholder": "Describe the goal"
    },
    "goalTypeSelect": {
      "label": "Goal type",
      "placeholder": "Select goal type"
    },
    "homeStatus": {
      "label": "Home status",
      "placeholder": "Select a home status"
    },
    "hourSelect": {
      "label": "Time",
      "optionLabel": "{hour, plural, one {# hour} other {# hours}}",
      "placeholder": "Select"
    },
    "invite": "Invite",
    "inviteParticipant": "Invite participant",
    "isNgo": {
      "content": "My organisation is an NGO.",
      "label": "NGO status"
    },
    "jobTitle": {
      "label": "Job Title",
      "placeholder": "Job title"
    },
    "language": {
      "label": "Language",
      "placeholder": "Select language"
    },
    "lastName": {
      "label": "Last Name",
      "placeholder": "Smith"
    },
    "learningConfidence": {
      "label": "Learning Confidence",
      "placeholder": "Learning Confidence"
    },
    "learningProgress": {
      "label": "Learning Progress",
      "placeholder": "Learning Progress"
    },
    "legalStatus": {
      "label": "Legal status",
      "placeholder": "Select a legal status"
    },
    "licenceExpirationDate": {
      "label": "Licence expiration date"
    },
    "licences": {
      "label": "Number of licences",
      "placeholder": "12"
    },
    "lifeEvent": {
      "label": "Life event"
    },
    "location": {
      "label": "Location",
      "placeholder": "Set location"
    },
    "locationAddress": {
      "label": "Address",
      "placeholder": "Main Square Nr. 2"
    },
    "locationDescription": {
      "label": "A short description or details about this location",
      "placeholder": "Location is easily accesible"
    },
    "locationName": {
      "label": "Name",
      "placeholder": "Main Square"
    },
    "locationPhoto": "Location Photo",
    "locationReports": "See reports",
    "locationSearch": {
      "label": "Search for a name or address",
      "placeholder": "10 Downing Street"
    },
    "membersSearch": {
      "label": "Search for a name or email",
      "placeholder": "John Doe | mail@domain.com"
    },
    "messageAttachment": {
      "label": "Attachment URL",
      "placeholder": "www.attachmenturl.com"
    },
    "messagesSearch": {
      "label": "Search by keyword",
      "placeholder": "Hello"
    },
    "messageText": {
      "label": "Message",
      "placeholder": "Hello"
    },
    "mood": {
      "label": "Mood",
      "placeholder": "Mood"
    },
    "moreInfo": {
      "label": "Description",
      "placeholder": "Give people some information about your team"
    },
    "name": {
      "label": "Name",
      "placeholder": "Enter name"
    },
    "nationality": {
      "label": "Nationality",
      "placeholder": "Nationality"
    },
    "newPassword": {
      "label": "New password",
      "placeholder": "Type your new password"
    },
    "nickname": {
      "label": "Nickname",
      "placeholder": "Jhonny"
    },
    "noteDescription": {
      "label": "Notes",
      "placeholder": "Write down your thoughts here"
    },
    "noteSearch": {
      "label": "Search by keyword",
      "placeholder": "Search by keyword"
    },
    "numberOfWeeks": {
      "label": "Number of weeks",
      "placeholder": "Number of weeks"
    },
    "officialAddress": {
      "label": "Official address",
      "placeholder": "2 Main Street"
    },
    "officialCountry": {
      "label": "Country",
      "placeholder": "Country Name"
    },
    "organizationName": {
      "label": "Organisation Name",
      "placeholder": "MobileSchool.org"
    },
    "participantRole": {
      "label": "Select role",
      "placeholder": "Select role"
    },
    "participantSearch": {
      "label": "Search by name",
      "placeholder": "John Smith"
    },
    "participantsSearch": {
      "label": "Search participants",
      "placeholder": "John Smith"
    },
    "password": {
      "label": "Password",
      "placeholder": "Type your password"
    },
    "phoneNumber": {
      "label": "Phone number",
      "placeholder": "123-456-7890"
    },
    "photoGallery": {
      "upload": "Upload an image"
    },
    "picture": {
      "delete": "Delete photo",
      "download": "Download photo",
      "message": "Message photo",
      "ngo": "NGO registration",
      "organization": "Organisation logo",
      "profile": "Profile photo",
      "remove": "Remove photo",
      "upload": "Upload an image"
    },
    "region": {
      "label": "Region",
      "placeholder": "Region"
    },
    "reminderDescription": {
      "label": "Notes",
      "placeholder": "Add your notes"
    },
    "remove": "Remove",
    "role": {
      "label": "Role",
      "placeholder": "Assign this user a role"
    },
    "save": "Save",
    "sessionAttachment": {
      "label": "Attachment URL",
      "placeholder": "www.attachmenturl.com"
    },
    "sessionSearch": {
      "label": "Search by intervention type or location",
      "placeholder": "Mobile School | Baudelopark"
    },
    "sessionType": {
      "label": "Intervention type",
      "placeholder": "Choose intervention type"
    },
    "dataOptionPhoto": "{optionName} photo",
    "skillCategorySelect": {
      "label": "Skill category",
      "placeholder": "Select a category"
    },
    "skillSelect": {
      "label": "Skill",
      "placeholder": "Select skill"
    },
    "skipAddingTeamMembers": "Skip",
    "startTime": {
      "label": "Start time",
      "placeholder": "14:30"
    },
    "surveySearch": {
      "label": "Search by title",
      "placeholder": "Feedback"
    },
    "surveyDescription": {
      "label": "Survey description",
      "placeholder": "How are you feeling?"
    },
    "surveyTitle": {
      "label": "Survey title",
      "placeholder": "About discrimination"
    },
    "surveyType": {
      "label": "Survey type"
    },
    "taxId": {
      "label": "Tax ID",
      "placeholder": "Tax ID (9 digit number)"
    },
    "teamMembersToTeamSearch": {
      "label": "Search organisation members",
      "placeholder": "John Smith"
    },
    "teamName": {
      "label": "Team name",
      "placeholder": "Give your team a name"
    },
    "teamPhoto": "Team photo",
    "teamSearch": {
      "label": "Search team",
      "placeholder": "Search team"
    },
    "title": {
      "label": "Title",
      "placeholder": "Title (optional, max. 50 characters)"
    },
    "topic": {
      "label": "Topic",
      "placeholder": "Topic"
    },
    "unregisteredParticipants": {
      "label": "Unknown participants",
      "placeholder": "12"
    },
    "validUntil": {
      "label": "Valid until"
    },
    "visibility": {
      "label": "Visible to",
      "placeholder": "Visible to"
    },
    "vitalStatus": {
      "label": "Vital status",
      "placeholder": "Vital status"
    },
    "website": {
      "label": "Website",
      "placeholder": "www.website.com"
    },
    "zipCode": {
      "label": "ZIP code",
      "placeholder": "ZIP code"
    }
  },
  "invitationStatus": {
    "ACCEPTED": "Joining",
    "DECLINED": "Not joining",
    "PENDING": "Not responded"
  },
  "kpiDomains": {
    "ACTIVITY": "Activities",
    "PARTICIPANT": "Participants",
    "SESSION": "Interventions"
  },
  "miscellaneous": {
    "all": "All",
    "notAvailable": "Not available",
    "notSet": "Not set",
    "unknown": "Unknown",
    "week": "Week {week}, {year}",
    "download": "Download"
  },
  "modals": {
    "addVendor": {
      "title": "Add vendor",
      "confirm": "Add"
    },
    "addMember": {
      "title": "Invite member",
      "confirm": "Invite"
    },
    "confirmationModals": {
      "remove": "Are you sure you want to delete this?",
      "edit": "Save changes?",
      "yes": "Yes",
      "no": "No"
    },
    "importMeals": {
      "title": "Import meals template"
    }
  },
  "navigation": {
    "users": "Users",
    "orders": "Orders",
    "menu": "Meals",
    "vendors": "Vendors",
    "organizations": "Organizations",
    "settings": "Settings",
    "platform": "Platform"
  },
  "navigationGroup": {
    "main": "Main menu",
    "organization": "Organisation",
    "teams": "Teams"
  },
  "noteTopics": {
    "ALL": "All",
    "DAYTIME_OCCUPATION": "Occupation",
    "GOALS": "Goals",
    "MOODS": "Moods",
    "PERSONAL_INFORMATION": "Personal information",
    "SKILLS": "Skills",
    "SOCIAL_MAP": "Social Map"
  },
  "noteVisibilities": {
    "ALL": "All",
    "ALL_TEAMS": "All teams",
    "MY_TEAM": "My team",
    "PRIVATE": "Only me"
  },
  "noteVisibilityFilter": {
    "ALL": "All",
    "PRIVATE": "Only me",
    "PUBLIC": "All teams"
  },
  "occurenceStatus": {
    "ALWAYS": "Always",
    "NEVER": "Never",
    "OFTEN": "Often",
    "RARELY": "Rarely",
    "SOMETIMES": "Sometimes"
  },
  "ordering": {
    "ascendent": "ascendent",
    "descendent": "descendent"
  },
  "pages": {
    "forgotPassword": {
      "backButton": "Back to log in",
      "subtitle": "Enter your e-mail address below to reset your password.",
      "title": "Forgot password?"
    },
    "meals": {
      "list": {
        "title": "Products",
        "addNew": "Add product",
        "importTemplate": "Import template"
      },
      "detail": {},
      "create": {
        "title": "Add meal"
      }
    },
    "orders": {
      "list": {
        "title": "Orders"
      }
    },
    "organizations": {
      "tabs": {
        "general": {
          "title": "General"
        },
        "diningSlots": {
          "title": "Dining Slots"
        },
        "members": {
          "title": "Members"
        },
        "access": {
          "title": "Access"
        }
      }
    },
    "vendors": {
      "tabs": {
        "profile": {
          "title": "Profile"
        },
        "members": {
          "title": "Members"
        },
        "products": {
          "title": "Products"
        },
        "general": {
          "title": "General"
        },
        "availability": {
          "title": "Availability"
        }
      }
    },
    "users": {
      "tabs": {
        "transactions": {
          "title": "Transactions"
        },
        "subscriptions": {
          "title": "Subscriptions"
        },
        "audit": {
          "title": "Audit Logs"
        }
      }
    },
    "resetLinkExpired": {
      "subtitle": "The link you are trying to access is no longer available. Please enter your email address below to request a new password link.",
      "title": "Password link expired"
    },
    "resetLinkSent": {
      "redirect": "Back to <a>Log In</a>.",
      "subtitle": "We've sent the email containing the password reset link. Check your inbox and spam folder in your email client.",
      "title": "Password reset link sent"
    },
    "resetPassword": {
      "title": "Reset your password"
    },
    "signIn": {
      "forgotPassword": "Forgot password?",
      "noAccountSignUp": "Don't have an account? <a>Register</a> easily now.",
      "signInButton": "Sign In",
      "subtitle": "Please log into your account.",
      "title": "Welcome back!"
    },
    "signUp": {
      "haveAccountSignIn": "Already have an account? <a>Log in</a>.",
      "signUpButton": "Sign Up",
      "subtitle": "Before we can register your organisation we need the following details",
      "title": "Register to StreetSmart Impact!"
    },
    "signUpEmailSent": {
      "back": "Back to login",
      "subtitle": "We've sent you an email to set the password for your new account. Check your inbox and spam folder in your email client.",
      "title": "Password link sent"
    },
    "superAdminDataCustomisation": {
      "tabs": {
        "dataOptions": "Data options"
      },
      "title": "Data customisation"
    }
  },
  "participantLegalSectionTypes": {
    "PARTICIPANT_HOME_STATUS": "Home status",
    "PARTICIPANT_LEGAL_DOCUMENTS": "Legal documents",
    "PARTICIPANT_LEGAL_STATUS": "Legal status"
  },
  "participantProfileFieldTypes": {
    "PARTICIPANT_ADDRESS_FIELD": "Address",
    "PARTICIPANT_FIRST_NAME_FIELD": "First name",
    "PARTICIPANT_LANGUAGE_FIELD": "Language",
    "PARTICIPANT_LAST_NAME_FIELD": "Last name",
    "PARTICIPANT_NATIONALITY_FIELD": "Nationality",
    "PARTICIPANT_STATE_FIELD": "Active - inactive",
    "PARTICIPANT_VITAL_STATUS_FIELD": "Vital Status",
    "PARTICIPANT_PHONE_NUMBER_FIELD": "Phone number"
  },
  "participantRoles": {
    "WRITE_ACCESS": {
      "description": "Access to every feature. {br} Can evaluate, but with approval.",
      "name": "Advanced"
    },
    "FULL_ACCESS": {
      "description": "Access to every feature. {br} Can evaluate freely.",
      "name": "Pro"
    },
    "NO_ACCESS": {
      "description": "Access to every feature, except the evaluation modules.",
      "name": "New user"
    }
  },
  "paymentStatusFilter": {
    "all": "All",
    "overdue": "Overdue",
    "paid": "Paid",
    "trial": "Trial period"
  },
  "paymentStatuses": {
    "CANCELED": "Canceled",
    "NOT_AVAILABLE": "Not Available",
    "OVERDUE": "Overdue",
    "PAID": "Paid",
    "PAYED": "Paid",
    "PENDING": "Pending",
    "TRIAL": "Trial Period"
  },
  "profileFields": {
    "GENERAL": "Custom organisation fields",
    "PERSONAL": "Custom profile fields",
    "defaultProfileFields": "Default profile fields",
    "legalInformation": "Legal information"
  },
  "questionType": {
    "MULTIPLE_CHOICE": "Multiple answers possible",
    "SINGLE_CHOICE": "Only one answer possible",
    "TEXT_INPUT": "Text input"
  },
  "reportMood": {
    "NEGATIVE_ACTIVE": "Negative-Active",
    "NEGATIVE_INACTIVE": "Negative-Inactive",
    "POSITIVE_ACTIVE": "Positive-Active",
    "POSITIVE_INACTIVE": "Positive-Inactive"
  },
  "roles": {
    "ADMIN": "Admin",
    "ORG_ADMIN": "Organization Admin",
    "ORG_MEMBER": "Member",
    "VENDOR_ADMIN": "Vendor Admin",
    "VENDOR_CASHIER": "Cashier"
  },
  "skillCategories": {
    "COGNITIVE": "Cognitive",
    "CUSTOM": "Custom",
    "PHYSICAL": "Physical",
    "SOCIAL_EMOTIONAL": "Socio-emotional"
  },
  "stateSwitch": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "surveyStatus": {
    "ACTIVE": "Active",
    "CLOSED": "Closed",
    "SCHEDULED": "Scheduled"
  },
  "surveyType": {
    "ALL": "All",
    "REGULAR": "Survey",
    "SESSION_FEEDBACK": "Intervention feedback"
  },
  "timeFilter": {
    "all": "All",
    "past": "Past",
    "upcoming": "Upcoming"
  },
  "timeFrame": {
    "MONTHLY": "Monthly",
    "WEEKLY": "Weekly",
    "YEARLY": "Yearly"
  },
  "validation": {
    "basic": {
      "array": {
        "max": "The {path} must have less than or equal to {max} items.",
        "min": "The {path} must have at least {min} items."
      },
      "date": {
        "max": "The {path} must be at earlier than {max}.",
        "min": "The {path} must be later than {min}."
      },
      "mixed": {
        "default": "The {path} is invalid.",
        "notOneOf": "The {path} must not be one of the following values: {values}.",
        "notType": "The {path} is required.",
        "oneOf": "The {path} must be one of the following values: {values}.",
        "required": "The {path} is required."
      },
      "number": {
        "integer": "The {path} must be an integer.",
        "lessThan": "The {path} must be less than {less}.",
        "max": "The {path} must be less than or equal to {max}.",
        "min": "The {path} must be greater than or equal to {min}.",
        "moreThan": "The {path} must be greater than {more}.",
        "negative": "The {path} must be a negative number.",
        "notEqual": "The {path} must be not equal to {notEqual}.",
        "positive": "The {path} must be a positive number."
      },
      "object": {
        "noUnknown": "The {path} cannot have keys not specified in the object shape."
      },
      "string": {
        "email": "The {path} is invalid.",
        "length": "The {path} must be exactly {length} characters.",
        "lowercase": "The {path} must be a lowercase string.",
        "matches": "The {path} must match the pattern \"{regex}\".",
        "max": "The {path} must be at most {max} characters.",
        "min": "The {path} must be at least {min} characters.",
        "trim": "The {path} must be a trimmed string.",
        "uppercase": "The {path} must be an upper case string.",
        "url": "The {path} must be a valid URL."
      }
    },
    "custom": {
      "fileSizeExceeded": "The {path} {index} file size must be less than {size} MB",
      "acceptAgreement": "The agreement must be accepted.",
      "isNgo": "Your organisation must be an NGO.",
      "minOneMonth": "Licences must be purchased for a minimum period of one month.",
      "passwordsDontMatch": "The passwords don't match.",
      "phoneNumber": "The {path} can contain only the following: digits, +, -, (, ) and space.",
      "time": "The {path} must be in the format HH:MM",
      "surveyDate": "Surveys cannot start in the past.",
      "selfEvaluation": "Self-evaluations cannot start in the past.",
      "taxId": "Only digits are allowed.",
      "timeInterval": "End time must be greater than start time"
    }
  },
  "allergens": {
    "WHEAT": "Wheat",
    "FISH": "Fish",
    "MILK": "Milk",
    "EGGS": "Eggs",
    "PEANUTS": "Peanuts",
    "SOYBEAN": "Soybean",
    "TREE_NUTS": "Tree nuts"
  }
}
